import { render, staticRenderFns } from "./CreateSubscription.vue?vue&type=template&id=165c896c&scoped=true&"
import script from "./CreateSubscription.vue?vue&type=script&lang=js&"
export * from "./CreateSubscription.vue?vue&type=script&lang=js&"
import style0 from "./CreateSubscription.vue?vue&type=style&index=0&id=165c896c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165c896c",
  null
  
)

export default component.exports